import { Box, BoxProps, Text } from '@chakra-ui/react';
import * as React from 'react';

import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';

export const BrokenImageFallback: React.FC<
  {
    altText: string;
    aspectRatio?: string;
  } & BoxProps
> = ({ altText, aspectRatio = '4/3', ...props }) => {
  if (!altText) {
    return (
      <ImageFallback aspectRatio={aspectRatio} borderRadius="lg" {...props} />
    );
  }

  return (
    <Box
      sx={{ aspectRatio }}
      overflowY="auto"
      overflowX="hidden"
      bg="gray.50"
      border="1px"
      borderColor="gray.200"
      borderRadius="lg"
      role="img"
      aria-label={altText}
      {...props}
    >
      <Box
        minH="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        px="3"
        py="2"
      >
        <Text
          fontSize="sm"
          color="gray.700"
          textAlign="center"
          whiteSpace="pre-wrap"
          wordBreak="break-word"
        >
          {altText}
        </Text>
      </Box>
    </Box>
  );
};
